"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OptionLabel = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Typography = require("../Typography");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // This is an accessibility trick. The inputs are not rendered, but when a
// voice over tool encounters this group it will say something like:
// "Option 1, selected, radio button, 1 of 2"


var OptionInput = _styledComponents.default.input.attrs({
  type: 'radio'
}).withConfig({
  displayName: "Option__OptionInput",
  componentId: "sjjkn8-0"
})(["clip:rect(1px,1px,1px,1px);position:absolute;"]);

var OptionLabel = (0, _styledComponents.default)(_Typography.P).attrs({
  as: 'label'
}).withConfig({
  displayName: "Option__OptionLabel",
  componentId: "sjjkn8-1"
})(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
exports.OptionLabel = OptionLabel;

function Option(_ref) {
  var checked = _ref.checked,
      id = _ref.id,
      name = _ref.name,
      size = _ref.size,
      text = _ref.text; // Changing the selected option is controlled at the fieldset level.
  // Events at the input level should be cancelled.

  var eventPreventDefault = function eventPreventDefault(event) {
    event.preventDefault();
  };

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(OptionInput, {
    "aria-selected": checked,
    checked: checked,
    id: id,
    name: name,
    onChange: eventPreventDefault
  }), _react.default.createElement(OptionLabel, {
    htmlFor: id,
    onClick: eventPreventDefault,
    size: size === 'small' ? size : undefined
  }, text));
}

var _default = Option;
exports.default = _default;